export default __webpack_public_path__ + "static/media/howItWorksFill.c8947427.svg";